import { useIsAuthenticated } from '@azure/msal-react';
import { Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import StyledButton from '../../components/shared/Button/StyledButton';
import Logo from '../../components/shared/Logo/Logo';
import StyledNotFound from './StyledNotFound';
import { useTranslation } from '../../hooks/useTranslation';

const NotFound = () => {
  const { t } = useTranslation();
  const isAuthenticated = useIsAuthenticated();

  return (
    <StyledNotFound>
      <Logo />
      <Stack sx={{ width: '10%' }} spacing={2}>
        <h1>{t('Sorry, the page does not exist.')}</h1>
        <p>
          {t(
            'You can click the back button of your browser, or go to the {{destination}}.',
            {
              destination: isAuthenticated ? t('dashboard') : t('homepage'),
            }
          )}
        </p>
        {/* Navigate to dashboard if authenticated, homepage if not */}
        <Link to={isAuthenticated ? '/dashboard' : '/'}>
          <StyledButton variant="contained" color="primary" size="small">
            {t('Go To {{destination}}', {
              destination: isAuthenticated ? t('Dashboard') : t('Homepage'),
            })}
          </StyledButton>
        </Link>
      </Stack>
    </StyledNotFound>
  );
};

export default NotFound;
